"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var middleware_1 = require("./middleware");
/**
 * @hidden Internal function to map action creators to store actions
 */
function mapActionsToDispatch(contextReference, actions, middleware) {
    if (middleware === void 0) { middleware = []; }
    if (actions === undefined || typeof actions !== 'function')
        return {};
    var initActions = actions(contextReference);
    return Object.keys(initActions).reduce(function (obj, key) {
        var _a;
        return __assign({}, obj, (_a = {}, _a[key] = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return middleware_1.runWithMiddleware(middleware, initActions, args, __assign({ actionName: key }, contextReference.meta));
        }, _a));
    }, {});
}
exports.mapActionsToDispatch = mapActionsToDispatch;
/**
 * @hidden Internal function to map action creators to store actions when there are no Providers available
 */
function mapActionsToDefault(initialState, meta, actions) {
    if (actions === undefined || typeof actions !== 'function')
        return {};
    var contextReference = {
        state: initialState,
        stores: {},
        setState: function (value) { throw new Error("Can't invoke 'setState' with " + value + " because provider does not exist"); },
        meta: meta
    };
    var initActions = actions(contextReference);
    return Object.keys(initActions).reduce(function (obj, key) {
        var _a;
        return __assign({}, obj, (_a = {}, _a[key] = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return initActions[key].apply(initActions, args);
        }, _a));
    }, {});
}
exports.mapActionsToDefault = mapActionsToDefault;



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-concise-state/dist/mapActions.js
// module id = 424
// module chunks = 0